<template>
  <main class="article  page-main">
    <section class="article-detail">
      <div class="article-detail-heading">
        <div class="article-detail-meta">
          <span class="article-detail-category" @click="goList">{{ $t('menuNotices') }}</span>
          <time class="article-detail-date" datetime="2021. 04.20">{{ $moment(desserts.noticePublishDate).format('YY.MM.DD') }}</time>
        </div>
        <div class="article-detail-title">
          <strong>{{ desserts.noticeTitle }}</strong>
        </div>
      </div>

      <loading v-if="loading" />

      <div v-else class="article-detail-content">
        <div v-if="desserts.summaries" class="article-detail-summary">
          <ul v-for="item in desserts.summaries" :key="item.noticeSummarySeq">
            <li>{{ item.noticeSummaryContents }}</li>
          </ul>
        </div>

        <html-view v-model="desserts.noticeContents" class="editor" />
      </div>

      <div class="share-wrap">
        <share
          :seq="Number($route.params.noticeId)"
          :title="desserts.noticeTitle"
          :type="'NOTICE'"
          :share-image="desserts.noticeImagePath"
        />
      </div>
    </section>

    <section v-if="desserts.previous || desserts.next" class="relate">
      <p class="relate-title">{{ $t('detail.wantNext') }}</p>
      <div class="relate-content">
        <div class="list list-default">
          <div v-if="desserts.previous" class="list-box">
            <router-link :to="{ name: this.$route.name , params : { locale: $route.params.locale, noticeId : desserts.previous.noticeSeq}}">
              <div class="list-cont">
                <p class="list-title">{{ desserts.previous.noticeTitle }}</p>
                <!--                <p v-if="desserts.previous.noticeSubTitle" class="list-desc">{{ desserts.previous.noticeSubTitle }}</p>-->
                <div>
                  <time class="list-date">{{ $moment(desserts.previous.noticePublishDate).format('YY.MM.DD') }}</time>
                </div>
              </div>
            </router-link>
          </div>
          <div v-if="desserts.next" class="list-box">
            <router-link :to="{ name: this.$route.name , params : { locale: $route.params.locale, noticeId : desserts.next.noticeSeq}}">
              <div class="list-cont">
                <p class="list-title">{{ desserts.next.noticeTitle }}</p>
                <!--                <p v-if="desserts.next.noticeSubTitle" class="list-desc">{{ desserts.next.noticeSubTitle }}</p>-->
                <div>
                  <time class="list-date">{{ $moment(desserts.next.noticePublishDate).format('YY.MM.DD') }}</time>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <div class="btn-wrap">
        <button type="button" class="btn" @click.prevent="goList">{{ $t('seeList') }}</button>
      </div>
    </section>
  </main>
</template>
<script>
import noticeApi from '@/api/notice'
import contentDetail from '@/mixins/contentDetail'

export default {
  components: {
    share: () => import('@/components/base/Share'),
    loading: () => import('@/components/base/Loading')
  },
  mixins: [contentDetail],
  data () {
    return {
      desserts: {},
      loading: false
    }
  },
  watch: {
    '$route.params.noticeId' () {
      this.getDetail()
    },
    '$route.params.locale' () {
      this.getDetail()
    }
  },
  mounted () {
    if (this.$route.query.sharekey) {
      this.getShareDetail()
    } else {
      this.getDetail()
    }
  },
  methods: {
    async getDetail () {
      this.loading = true
      const { data } = await noticeApi.getNoticeDetail(this.$route.params.noticeId, {
        language: this.isKorean ? 'KR' : 'EN'
      })

      if (data) {
        this.desserts = data
        this.setContents()
      }
      this.loading = false
    },
    async getShareDetail () {
      this.loading = true
      const { data } = await noticeApi.getNoticeLink({
        linkKey: this.$route.query.sharekey,
        language: this.isKorean ? 'KR' : 'EN'
      })

      if (data) {
        this.desserts = data
        this.setContents()
      }
      this.loading = false
    },
    goList () {
      this.$router.push({ name: 'Notice', query: { page: 1 } })
    },
  }
}
</script>
